export enum PromptTabs {
  AllPrompts = "AllPrompts",
  SavedPrompts = "SavedPrompts",
  GroupPrompts = "GroupPrompts",
}
